import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import JsonCSV from 'vue-json-csv'

Vue.component('downloadCsv', JsonCSV)
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  // apiKey: "AIzaSyC5bSFGpXC10Mxrg9iUVa9Uxc5ZolZ4Ovs",
  // authDomain: "rekyc-dashboard.firebaseapp.com",
  // projectId: "rekyc-dashboard",
  // storageBucket: "rekyc-dashboard.appspot.com",
  // messagingSenderId: "186772325672",
  // appId: "1:186772325672:web:6189b4bd688afb75537c1d",
  // measurementId: "G-9LQVQDZHK5"
  apiKey: "AIzaSyCnYEMCJW72FC6o5DH2sjITROcaelhKkZY",
  authDomain: "zebu-admin-v3.firebaseapp.com",
  projectId: "zebu-admin-v3",
  storageBucket: "zebu-admin-v3.appspot.com",
  messagingSenderId: "437830617550",
  appId: "1:437830617550:web:b1c3265fad4f766680c39f",
  measurementId: "G-TBEL9EM6W6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
console.log(analytics);
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
